<template>
  <div id="search">
    <call />
      <pop-alert />
      <!-- header -->
      <header>
        <header-app :rate="counterBlock" :canMobileOrder="isMobileOrderEnabled()"></header-app>
        <span><menu-app></menu-app></span>
        <div class="ssm-overlay ssm-toggle-nav"></div>
      </header>
      <!-- main -->
      <main>
        <!-- nav bot -->
        <footer-app page="search"></footer-app>
        <!-- search -->
        <section>
          <div class="l-search">
            <div class="l-search__head">
              <div class="l-search__box-search">
                <div class="l-search__box-search--box d-flex c-box-coupon">
                  <div><input type="text" placeholder="検索キーワード" v-model="inputSearch" /></div>
                  <button @click.prevent="searchName()">検索</button>
                </div>
              </div>
            </div>
            <div class="l-search__body">

              <div class="l-search__title">
                <img
                  src="/assets/images/icon/icon-title-bag.svg"
                  alt=""
                />ショップカテゴリー
              </div>
              <ul class="c-store-cat">
                <li>
                  <router-link to="/shop/list">
                    <div class="c-store-cat__icon">
                      <img src="/assets/images/icon/icon-store-cat-1.svg" alt="" />
                    </div>
                    <div class="c-store-cat__text">すべて</div>
                  </router-link>
                </li>
                <li>
                  <router-link to="/shop/list/1">
                    <div class="c-store-cat__icon">
                      <img src="/assets/images/icon/icon-store-cat-2.svg" alt="" />
                    </div>
                    <div class="c-store-cat__text c-store-cat__text--sm">
                      スーパーマーケッ<br />ト・総合スーパー
                    </div>
                  </router-link>
                </li>
                <li>
                  <router-link to="/shop/list/2">
                    <div class="c-store-cat__icon">
                      <img src="/assets/images/icon/icon-store-cat-3.svg" alt="" />
                    </div>
                    <div class="c-store-cat__text">ファッション</div>
                  </router-link>
                </li>
                <li>
                  <router-link to="/shop/list/3">
                    <div class="c-store-cat__icon">
                      <img src="/assets/images/icon/icon-store-cat-4.svg" alt="" />
                    </div>
                    <div class="c-store-cat__text">グッズ</div>
                  </router-link>
                </li>
                <li>
                  <router-link to="/shop/list/4">
                    <div class="c-store-cat__icon">
                      <img src="/assets/images/icon/icon-store-cat-5.svg" alt="" />
                    </div>
                    <div class="c-store-cat__text">サービス</div>
                  </router-link>
                </li>
                <li>
                  <router-link to="/shop/list/5">
                    <div class="c-store-cat__icon">
                      <img src="/assets/images/icon/icon-store-cat-6.svg" alt="" />
                    </div>
                    <div class="c-store-cat__text">グルメ<br />・フード</div>
                  </router-link>
                </li>
                <li>
                  <router-link to="/shop/list/6">
                    <div class="c-store-cat__icon">
                      <img src="/assets/images/icon/icon-store-cat-7.svg" alt="" />
                    </div>
                    <div class="c-store-cat__text">アミューズ<br />メント</div>
                  </router-link>
                </li>
              </ul>
              <div v-if="isReservationEnabled">
                <div class="l-search__title mt-16">
                  <img
                    src="/assets/images/icon/icon-title-bag.svg"
                    alt=""
                  />来店予約がある店舗から探す
                </div>
                <ul class="c-store-cat type-reservation">
                  <li>
                    <router-link to="/shop/list?type=reservation">
                      <div class="c-store-cat__icon">
                        <img src="/assets/images/icon/icon-reservationv2.svg" alt="" />
                      </div>
                      <div class="c-store-cat__text">来店予約</div>
                    </router-link>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </section>
        <!-- modal show congestion degree in header -->
        <modal_congestion_situation :counter-blocks=counterBlocks></modal_congestion_situation>
      </main>
    </div>
</template>

<script>
import "core-js/stable";
import "regenerator-runtime/runtime";
import Vue from "vue";
import Header from "../components/Header.vue";
import Footer from "../components/Footer.vue";
import Menu from "../components/Menu.vue";
import ModalCongestionSituation from "../components/ModalCongestionSituation.vue";
import { Common } from "../common/common.js";
import { Tenant } from "../plugin/mixin.js";
import { getProviderByShopCategory, getListShopProviders } from "../store/firestore.js";
import PopAlert from "../components/PopAlert.vue";

export default Vue.extend({
  name: "Search",
  components: {
    'footer-app': Footer,
    'header-app': Header,
    'menu-app': Menu,
    'modal_congestion_situation': ModalCongestionSituation,
    PopAlert
  },
  mixins: [Tenant],
  data () {
    return {
      providers: [],
      inputSearch: '',
      isReservationEnabled: false
    }
  },
  created () {
    this.getProviders()
  },
  mounted() {
    Common.initDom();
  },
  methods: {
    async getProviders () {
      const shopId = this.$store.state.shopId;
      this.providers = await getListShopProviders(shopId)
      
      for (var i=0; i<this.providers.length; i++ ) {
      //来店予約のある店舗を検索　一つでもヒットすればボタンを表示する
        if (this.providers[i].reservationEnabled) {
          this.isReservationEnabled = true;
          break;
        }
      }
    },
    searchName () {
      this.$router.push({ path: `/shop/list` , query: { keyword: this.inputSearch }});
    }
  }
});
</script>